import { Section, SectionType } from './section';

export interface TextSection extends Section {
    type: SectionType.text;

    html: string;
}

export function isTextSection(section?: Section): section is TextSection {
    return !!section && section.type === SectionType.text;
}
